var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data.questionFile),function(file,f){return _c('div',{key:f},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-12"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.getUrlFile(file.url)),expression:"getUrlFile(file.url)"}],attrs:{"alt":"Image"}})])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }